(function(){
  function init(){
    var hov=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var flips=[].slice.call(document.querySelectorAll('.cm-flip'));
    flips.forEach(function(f){
      if(f.dataset.cmReady)return;f.dataset.cmReady='1';
      if(hov){
        f.addEventListener('mouseenter',function(){f.classList.add('is-flipped')});
        f.addEventListener('mouseleave',function(){f.classList.remove('is-flipped')});
        f.addEventListener('focus',function(){f.classList.add('is-flipped')});
        f.addEventListener('blur',function(){f.classList.remove('is-flipped')});
      }else{
        f.addEventListener('click',function(e){e.stopPropagation();var on=f.classList.contains('is-flipped');flips.forEach(function(x){x.classList.remove('is-flipped')});if(!on)f.classList.add('is-flipped');});
      }
    });
    if(!hov){
      document.addEventListener('click',function(){flips.forEach(function(x){x.classList.remove('is-flipped')})});
      if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(en){if(!en.isIntersecting)en.target.classList.remove('is-flipped')})},{threshold:.2});flips.forEach(function(f){io.observe(f)});}
    }
    var rv=[].slice.call(document.querySelectorAll('.cm-rv'));
    if('IntersectionObserver' in window){
      var io2=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io2.unobserve(en.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
      rv.forEach(function(el){io2.observe(el)});
    }else{rv.forEach(function(el){el.classList.add('in')})}
    [].slice.call(document.querySelectorAll('.cm video[data-wide]')).forEach(function(v){
      var wide=window.matchMedia('(min-aspect-ratio: 1/1)').matches;
      v.poster=wide?v.dataset.widePoster:v.dataset.tallPoster;
      v.src=wide?v.dataset.wide:v.dataset.tall;v.muted=true;
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){v.removeAttribute('autoplay');}
      else{var p=v.play();if(p&&p.catch)p.catch(function(){});}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
